import React from "react";
import Logo from "src/assets/images/MuztransLogo.png";
import Image from "src/assets/images/BG-Tile.svg"

export const AuthenticationWrawperForError = ({ children }) => {
  return (
    <div
      className="vh-100 vw-100 main-div row m-0"
      style={{ backgroundImage: `url(${Image})` }}
    >
      <div style={{color:"white"}} className="d-flex flex-column justify-content-center align-items-center">
        {children}
      </div>
    </div>
  );
};
